import React from "react";
import StatusChip from "../common/StatusChip";
import LaunchStatusChip from "../AdLaunch/LaunchStatusChip";
import { formatDisplayDateTime } from "../../utils/helperFunctions";

const Field = ({ label, value, mono = false }) => (
  <div className="min-w-0">
    <p className="text-[11px] font-semibold uppercase tracking-wider text-gray-400">
      {label}
    </p>
    <p
      className={`truncate text-sm text-gray-700 ${mono ? "font-mono text-xs" : ""}`}
      title={typeof value === "string" ? value : undefined}
    >
      {value || "—"}
    </p>
  </div>
);

/** Launch state per hook, mirroring the Ad Launch table. Expects deliveries that carry `launch`. */
export default function LaunchDetails({ deliveries }) {
  return (
    <div className="space-y-4">
      {deliveries.map((d) => (
        <div key={d.id}>
          <div className="mb-2 flex flex-wrap items-baseline gap-x-2">
            <span className="text-sm font-semibold text-gray-800">
              Hook {d.hook_number ?? "—"}
            </span>
            <span
              className="w-full truncate font-mono text-[11px] text-gray-400"
              title={d.hook_name || d.ad_name || ""}
            >
              {d.hook_name || d.ad_name || "—"}
            </span>
          </div>

          <div className="rounded-lg border border-gray-200 bg-white px-4 py-3">
            <div className="mb-3 flex flex-wrap items-center gap-2">
              <LaunchStatusChip status={d.launch.status} />
              {d.launch.meta_live_status && (
                <StatusChip
                  subtle
                  size="small"
                  status={d.launch.meta_live_status}
                />
              )}
              {d.launch.meta_adset_url && (
                <a
                  href={d.launch.meta_adset_url}
                  target="_blank"
                  rel="noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  className="ml-auto text-xs font-medium text-primaryPurple hover:underline"
                >
                  Open in Ads Manager
                </a>
              )}
            </div>

            <div className="grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2 lg:grid-cols-4">
              <Field
                label="Ad account"
                value={
                  d.launch.meta_ad_account_name || d.launch.meta_ad_account_id
                }
              />
              <Field label="Meta ad ID" value={d.launch.meta_ad_id} mono />
              <Field label="Campaign ID" value={d.launch.meta_campaign_id} mono />
              <Field
                label="Launched"
                value={
                  d.launch.launched_at
                    ? formatDisplayDateTime(d.launch.launched_at)
                    : ""
                }
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
